import React from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText, Table } from '@gaiads/telia-react-component-library';
import { BundleItemOverview } from '@cdaas/api-clients/dist/product-service-openapi';

interface VariantListItemProps {
  item: BundleItemOverview;
  main?: boolean;
  groupName?: string;
}

const VariantListItem = ({ item }: VariantListItemProps) => {
  const { t } = useTranslation('bundlesview');
  const { name, options } = item;
  const variantCount = options.length;
  const groupName = name && name.trim().length > 1 ? name : null;

  // Add separator (comma) if more than one item and not added to last one
  const addSeparator = (addOnName: string, addOnTotalCount: number, index: number) => {
    const separatorOrEmptySpace = index + 1 < addOnTotalCount ? ', ' : '';
    return `${addOnName}${separatorOrEmptySpace}`;
  };

  return (
    <Table.Row className="telia-react-table_row__child">
      <Table.Cell></Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell className="daas-product-table__name">
        <BodyText>
          {`${t('bundles_table.addons')}: `}
          {groupName}
          {!groupName && options.map((variant, index) => addSeparator(variant.name, variantCount, index))}
        </BodyText>
      </Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell>
        <BodyText>{t('bundles_table.variants_count', { count: variantCount })}</BodyText>
      </Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell></Table.Cell>
    </Table.Row>
  );
};

export default VariantListItem;
